import axios from 'axios';
import { getAuthHeaders } from '../Auth';
import exportedConfig from '../config';

type Background = {
    mode: string;
    prompt: string;
};
export const postStylizeImageUrl = async ({
    body,
    signal,
}: {
    body: {
        imageUrl: string;
        style: string;
        background: Background;
    };
    signal: AbortSignal;
}): Promise<string> => {
    try {
        const headers = await getAuthHeaders();
        const response = await axios.post(`${exportedConfig.backendServiceUrl}/api/v3/inspiration:stylizePhoto`, body, {
            signal,
            headers,
        });

        if (!response.data) {
            throw new Error('Empty response from API');
        }

        if (!response.data.imageUrl) {
            console.error('API Response:', response.data);
            throw new Error('API response missing imageUrl field');
        }

        return response.data.imageUrl;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error('API Error:', error.response?.data || error.message);
            throw new Error(`API request failed: ${error.response?.data?.message || error.message}`);
        }
        console.error('Error stylizing image:', error);
        throw error;
    }
};
